import React, { Component, createRef, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import Page from '../../components/page';
import asccp from '../../service/asccp';
import Footer from '../../components/footer';
import "./app.css";
import "./steps.css";
import FLoatingPDF from '../components/floatingPDF';
const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );
  let algorithms = require("../../data/algorithms.json");

class Management extends Component {

    constructor(props) {
        super(props);
        this.childRef = React.createRef();

        this.state = {
            location:this.props.locationData,
            page: {},
            diagnoses: [],
            facts: {},
            state: "intro",
            currentAlgorithm:null,
            currentDiagnosis:"",
            currentComorbid:"",
            hidePDF:"hidden",
            pdf:"",
            isCalc:false,
            displayOverlay:"none"
        };

        this.setVariable = this.setVariable.bind(this);
        this.getVariable = this.getVariable.bind(this);
        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPrevPage = this.goToPrevPage.bind(this);
        this.nextPageDelay = this.nextPageDelay.bind(this);
        this.togglePDF = this.togglePDF.bind(this);
        this.startOver = this.startOver.bind(this);
        this.reloadPage = this.reloadPage.bind(this);

        let tt = this;
        var currentTab = "#nav-management";
        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var target = $(e.target).attr("href");
            currentTab = target;
        });

        document.getElementById("nav-management-tab").addEventListener("click", function() {
            if (currentTab == "#nav-management") {
                tt.startOver();
            }
        });
        
        if(this.state.location != null) {
            this.state.page = this.state.location;
            this.nextPageDelay(); // Using a timer delay so the page loads before calling goToNextPage
        }

        /*
        if(new URLSearchParams(this.state.location.search).get('name') != null) {
            this.setVariable("diagnosis", new URLSearchParams(this.state.location.search).get('name'))
        }
        */
    }

    nextPageDelay = async event=> { // After delay, loads the next page
        await delay(1);
        this.goToNextPage();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.algo !== this.props.algo) {
            this.loadIt(this.props.algo);
        }
    }

    contextData() {
        var url = new URL(window.location.href);
        var c = url.searchParams.get("context");
        if (c) {
            var datas = c.split('.');
            if (datas.length > 2) {
                var params = atob(datas[1]);
                var data = JSON.parse(params);
                return {context: c, data: data};
            }
        }
        return null;
    }

    
    loadIt(algo) {
        if (!algo) {
            return;
        }

        let page = this.state.page;
        this.state.currentAlgorithm = algo;

        var json = require('../../data/' + algo.algorithm + '.json');

        var diagnosis = algo.diagnosis;
        var age = algo.age;

        asccp.setAlgorithm(json);
        asccp.setVariable('comorbidities', comorbidities);
        asccp.setVariable('patient_age', age);
        asccp.setVariable('partum', partum);
        asccp.setVariable("diagnosis", diagnosis);

        this.state.currentDiagnosis = diagnosis;
        this.state.pdf = algo.pdf;

        var data = asccp.reevaluate("intro");
        data.state = "intro";
        this.setState({ page: data, state: "intro" });
        
        console.log(window.location.href);
        var cx = this.contextData();
        if (cx) {
            this.fetchAndSetContext(cx);
        }
    }

    setFacts = (facts) => {
        var vars = Object.keys(facts);
        var medHist = false;
        for(var i=0;i<vars.length;i+=1) {
            var fid = vars[i];
            var fact = facts[fid];
            if (fact !== null) {
                var fvalue = fact.value;
                asccp.setVariable(fid, fvalue);
                if(fid.includes("medication_") && !medHist) {
                    console.log('test id ' + fid + "   value  " + fvalue)
                    asccp.setVariable("medication_history", "Yes");
                }
            }
        }
    }

    fetchAndSetContext = (cx) => {
        fetch('https://api.clinicalalgorithms.com/v1/data/' + cx.data.source, { 
            method: 'GET', 
            mode: 'cors', // no-cors
            headers: new Headers({
                'Authorization': 'Bearer ' + cx.context, 
                'Accept': 'application/json'
            }), 
        }).then( response => {
            if (!response.ok) {
                throw new Error("HTTP error " + response.status);
            }
            return response.json();
        }).then(json => {
            
            this.setFacts(json.facts);
            var data = asccp.reevaluate("intro");
            data.state = "intro";
            console.log(data);
            this.setState({ page: data, state: "intro", facts: json.facts });
        });
    }

    rebuildDiagnosisVariables = () => {
        let diagnosisName = this.getVariable("diagnosis");
        if(diagnosisName == null || diagnosisName == "Select") {
            return;
        }

        let age = this.getVariable("patient_age");
        let diagnosis = this.state.diagnoses.find((d) => d.title == diagnosisName && d.age.indexOf(age) >= 0 );
        if (diagnosis == null) {
            return;
        }

        for(var i=0;i<algorithms.length;i++) {
            if(algorithms[i].diagnosis == diagnosis.name) {
                this.state.pdf = algorithms[i].pdf;
                this.state.currentAlgorithm = algorithms[i];
            }
        }
      };

    setVariable = (id, value) => {
        asccp.setVariable(id, value);
        // reset patient_age and sub_age if we change the diagnosis
        if(id == "diagnosis") {
           // asccp.setVariable("_patient_age", "");
           // asccp.setVariable("sub_age", "");
        }
        if (this.state.page.title == "Diagnosis") {
            this.rebuildDiagnosisVariables();
          }

        var data = asccp.reevaluate(this.state.state);
        data.state = this.state.state;
        this.setState({ page: data });
    }

    getVariable = (id) => {
        return asccp.getVariable(id);
    }

    goToNextPage = () => {

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
          });

        let page = this.state.page;

        if (page.title == "Diagnosis") {

            let diagnosisName = this.getVariable("diagnosis");
            let age = this.getVariable("patient_age");

            let fullDiagnosis = this.state.diagnoses.find(d => d.title === diagnosisName && d.age.indexOf(age) >= 0 );
            if (!fullDiagnosis) {
                return;
            }

            let diagnosis = {
                value: fullDiagnosis.name
            };

            this.state.currentDiagnosis = diagnosis.value;

            for(var i=0;i<algorithms.length;i++) {
                if(algorithms[i].diagnosis == diagnosis.value) {
                    this.state.pdf = algorithms[i].pdf;
                    this.state.currentAlgorithm = algorithms[i];
                    break;
                }
            }

            this.setVariable("algorithm", fullDiagnosis.filename);
            var json = require('../../data/' + fullDiagnosis.filename + '.json');
            json = atob(json.data);
            json = JSON.parse(json);
            asccp.setAlgorithm(json);            

            var facts = this.state.facts || {};
            this.setFacts(facts);
            
            var data = asccp.reevaluate("intro");
            let idx = data.content.length;
            data.state = nextState;
            this.setState({ page: data, state: "intro" });
            
            if(idx > 0) {
                this.state.state = "intro";
                data.state = nextState;
                this.setState({ page: data, state: "intro" });
            } else {
                if(this.state.state == "intro") {
                    nextState = "confirmation";
                } else if (this.state.state == "confirmation") {
                    nextState = "recommendation";
                }
                data = asccp.reevaluate(nextState);
                data.state = nextState;
                this.setState({ page: data, state: nextState });
            }

            if (window.reevaluate) {
                window.reevaluate(nextState);
            }

        } else {

            var nextState = this.state.state;
            if(nextState == "intro") {
                nextState = "confirmation";
            } else if(nextState == "confirmation") {
                nextState = "recommendation";
            }

            if (nextState == "recommendation") {
                let tt = this;
                let body =  JSON.stringify(asccp.vars());
                
                this.setState({displayOverlay:"block"});
                
                var baseUrl = 'https://api.asccp.org/v2/';
                if (document.location.origin == "file://" || 
                  document.location.hostname == "localhost"|| 
                  document.location.hostname == "asccp-dev.zimmdot.com") {
                    baseUrl = 'https://api-asccp-dev.zimmdot.com/';
                }
                // baseUrl = 'http://localhost:3002/';

                fetch(baseUrl, {
                    method: 'POST', 
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + window.getToken(), 
                        'Content-Type': 'application/json'
                    }, 
                    body: body
                })
                .then(function(res) {
                    return res.json();
                   })
                .then(function(data) {
                    data.state = "recommendation";
                    if(data.figure != null) {
                        tt.state.pdf =  data.figure[0].split("_")[0];
                    }
                    tt.setState({displayOverlay:"none"});
                    tt.setState({ page: data, state: nextState });
                })
            } else {
                
                var data = asccp.reevaluate(nextState);
                data.state = nextState;
                if(data.figure != null) {
                    this.state.pdf =  data.figure[0].split("_")[0];
                }
                this.setState({ page: data, state: nextState });
            }
        }
    }

    goToPrevPage = () => {

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
          });
          
        let page = this.state.page;
        
        if(page.state == "recommendation" && this.state.currentAlgorithm != null) {
            this.state.pdf = this.state.currentAlgorithm.pdf;
        }

        if (page.title == "Diagnosis") {

            let diagnosis = page.content.find(c => c.id == "diagnosis");
            let age = this.getVariable("patient_age");
            
            this.state.currentDiagnosis = diagnosis.value;

            for(var i=0;i<algorithms.length;i++) {
                if(algorithms[i].diagnosis == diagnosis.value) {
                    this.state.pdf = algorithms[i].pdf;
                }
            }

            let fullDiagnosis = this.state.diagnoses.find(d => d.title === diagnosis.value && d.age.indexOf(age) >= 0 );
            if (!fullDiagnosis) {
                return;
            }

            var json = require('../../data/' + fullDiagnosis.filename + '.json');
            asccp.setAlgorithm(json);

            var data = asccp.reevaluate("intro");
            let idx = data.content.length;

            data.state = nextState;
            this.setState({ page: data, state: "intro", facts: {} });

            if(idx > 0) {
                this.state.state = "intro";
                data.state = nextState;
                this.setState({ page: data, state: "intro", facts: {} });
            } else {
                var nextState = this.state.state;
                if(nextState == "intro") {
                    nextState = "confirmation";
                } else if(nextState == "confirmation") {
                    nextState = "recommendation";
                }
                data = asccp.reevaluate(nextState);
                data.state = nextState;
                this.setState({ page: data, state: nextState });
            }


        } else {
            if(this.state.state == "intro") {
                this.state.currentDiagnosis = "";
                var json = require('../../data/global.json');
                asccp.setAlgorithm(json);
                nextState = "intro";
            }

            if(this.state.state == "medication") {
                nextState = "intro";
                var data = asccp.reevaluate(nextState);
                data.state = nextState;
                this.setState({ page: data, state: nextState });
                var data = asccp.reevaluate("intro");
                let idx = data.content.length;
    
                data.state = nextState;
                this.setState({ page: data, state: "intro", facts: {} });
            } else if(this.state.state == "recommendation" ) {
                nextState = "confirmation";
                var data = asccp.reevaluate(nextState);
                data.state = nextState;
                this.setState({ page: data, state: nextState });
                return;
            } else if(this.state.state == "confirmation" ) {
                nextState = "intro";
                var data = asccp.reevaluate(nextState);
                data.state = nextState;
                this.setState({ page: data, state: nextState });
                return;
            }

            var nextState = this.state.state;
            var data = asccp.reevaluate(nextState);
            data.state = nextState;
            this.setState({ page: data, state: nextState });
        }
    }

    togglePDF = (pdfName) => {
        if(pdfName == "" || pdfName == null) {
            return;
        }
        if(pdfName != null && typeof(pdfName) == "string") {
            this.setState({pdf:pdfName})
        }
        if(this.state.hidePDF == "visible") {
            this.setState(state =>({
                hidePDF: "hidden"
            }))
        } else {
            this.setState(state =>({
                hidePDF: "visible"
            }))
        }
    }

    render() {
        var diagnosisTitle = "";
        diagnosisTitle = this.state.currentComorbid + " " + this.state.currentDiagnosis;

        return (
            <div>
            <div style={{position:"relative", float:"center"}}>
                
            <div id="overlay" style={{display:this.state.displayOverlay}}><div class="loader"></div></div>
                <div className="App">
                    <Page
                        page={this.state.page}
                        state={this.state.state}
                        diagnoses={this.state.diagnoses}
                        facts={this.state.facts}
                        setVariable={this.setVariable}
                        getVariable={this.getVariable}
                        goToNextPage={this.goToNextPage}
                        goToPrevPage={this.goToPrevPage}
                        startOver={this.startOver}
                        togglePDF={this.togglePDF}
                        algorithm={this.state.currentAlgorithm} />
                </div>
                <FLoatingPDF pdfName={this.state.pdf} isHidden={this.state.hidePDF} togglePDF={this.togglePDF}/>
            </div>
            </div>
        )
    }

    reloadPage = () => {
        asccp.startOver();
        this.state.currentDiagnosis = "";
        var diagnoses = require('../../data/diagnoses.json');
        var json = require('../../data/global.json');
        console.log('g2');

        asccp.setAlgorithm(json);
        var data = asccp.reevaluate("intro");
        data.state = "intro";
        this.setState({ page: data, diagnoses: diagnoses, state: "intro", facts: {} });
    }

    startOver = () => {
        let myModal = new bootstrap.Modal(document.getElementById("startOver"), {
            backdrop: 'static',
        });
        myModal.show();

        let tt = this;
        document.getElementById('startOverYes').addEventListener('click', () => {
            myModal.hide();
            tt.reloadPage();
        });
    }

    componentDidMount() {
        if(this.props.algo == null || (typeof this.props.algo) != "string") {
            this.state.isCalc = false;
            var diagnoses = require('../../data/diagnoses.json');
            var json = require('../../data/global.json');
            asccp.setAlgorithm(json);
            var data = null;

            if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            {
                data = asccp.reevaluate("intro");
                data.state = "intro";
                if(data.figure != null) {
                    this.state.pdf =  data.figure[0].split("_")[0];
                }
            } else {
                var cx = this.contextData();
                if (cx) {
                data = cx.data;
                    if (data.context && data.context.diagnosis) {
                        diagnoses = diagnoses.filter( d => d.title == data.context.diagnosis);
                        asccp.setVariable("diagnosis", data.context.diagnosis);
                    }
                    this.fetchAndSetContext(cx);
                }
            }

            data = asccp.reevaluate("intro");
            data.state = "intro";
            console.log(data);
            this.setState({ page: data, diagnoses: diagnoses, state: "intro", facts: {} });
            
            if (!this.props.algo) {
                return;
            }

            this.loadIt(this.props.algo);
        } else {
            this.state.isCalc = true;
            var diagnoses = require('../../data/diagnoses.json');
            var json = require('../../data/' + this.props.algo + '.json');
            asccp.setAlgorithm(json);
            var data = asccp.reevaluate("intro");
            data.state = "intro";
            console.log(data);
            this.setState({ page: data, diagnoses: diagnoses, state: "intro", facts: {} });
        }

    }

    componentWillUnmount() {
        asccp.startOver();
    }
}

export default Management;
